const ROOT_SELECTOR = '[data-segmented-toggle-root]';
const TOGGLE_SELECTOR = '[data-segmented-toggle]';
const TAB_SELECTOR = '[data-segmented-toggle-tab]';
const THUMB_SELECTOR = '[data-segmented-toggle-thumb]';
const PANEL_SELECTOR = '[data-segmented-toggle-panel]';

export function initSegmentedToggle(): void {
  document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach(initSegmentedToggleRoot);
  document.querySelectorAll<HTMLElement>(TOGGLE_SELECTOR).forEach((toggle) => {
    if (!toggle.closest(ROOT_SELECTOR)) {
      initSegmentedToggleControl(toggle);
    }
  });
}

function initSegmentedToggleRoot(root: HTMLElement): void {
  const toggle = root.querySelector<HTMLElement>(TOGGLE_SELECTOR);
  if (!toggle) return;

  initSegmentedToggleControl(toggle, root);
}

function initSegmentedToggleControl(toggle: HTMLElement, root?: HTMLElement | null): void {
  const tabs = toggle.querySelectorAll<HTMLButtonElement>(TAB_SELECTOR);
  const thumb = toggle.querySelector<HTMLElement>(THUMB_SELECTOR);
  const panelRoot = root ?? toggle.closest<HTMLElement>(ROOT_SELECTOR);
  const panels = panelRoot?.querySelectorAll<HTMLElement>(PANEL_SELECTOR) ?? [];

  if (!tabs.length || !thumb) return;

  const activate = (activeTab: HTMLButtonElement): void => {
    const id = activeTab.getAttribute('data-segmented-toggle-tab');

    tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('segmented-toggle__btn--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    updateThumb(toggle, thumb, activeTab);

    if (!id || !panels.length) return;

    panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-segmented-toggle-panel') === id;
      panel.classList.toggle('segmented-toggle-panel--hidden', !isActive);
    });
  };

  const initialTab =
    toggle.querySelector<HTMLButtonElement>(`${TAB_SELECTOR}.segmented-toggle__btn--active`) ??
    tabs[0];

  activate(initialTab);

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activate(tab));
  });

  const updateActiveThumb = (): void => {
    const current = toggle.querySelector<HTMLButtonElement>(
      `${TAB_SELECTOR}.segmented-toggle__btn--active`,
    );
    if (current) updateThumb(toggle, thumb, current);
  };

  if (typeof window.ResizeObserver !== 'undefined') {
    const resizeObserver = new window.ResizeObserver(updateActiveThumb);
    resizeObserver.observe(toggle);
  }

  window.addEventListener('resize', updateActiveThumb);
}

function updateThumb(
  toggle: HTMLElement,
  thumb: HTMLElement,
  activeTab: HTMLButtonElement,
): void {
  thumb.style.width = `${activeTab.offsetWidth}px`;
  thumb.style.transform = `translateX(${activeTab.offsetLeft}px)`;
}
